import React from "react";
import "./About.css";

function About() {
  return (
    <section className="about" id="about">
      <div className="about-container">
        
        {/* LEFT SIDE - Image */}
        <div className="about-image">
          <img src="/profile.jpeg" alt="Sanjana" />
        </div>

        {/* RIGHT SIDE - Text */}
        <div className="about-text">
          <h2>About Me</h2>
          <p>
            Hey 👋 I'm <span className="highlight"></span> a creative{" "}
            <span className="highlight">React Frontend Developer</span> and{" "}
            <span className="highlight">AI-powered Content Creator</span>.
          </p>
          <p>
            I specialize in building <b>modern, responsive websites</b> using
            React, and I’m enthusiastic about becoming a{" "}
            <span className="highlight">Full-Stack Developer</span>.  
            I can create professional <b>landing pages with email integration</b>, 
            ensuring businesses connect with their audience effectively.
          </p>
          <p>
            Alongside development, I explore <b> AI storytelling</b>,{" "}
            <b>animated video creation</b>, and <b>advertising content</b> — 
            blending technology with creativity to craft engaging digital experiences.
          </p>
          <p>
            My goal is to combine <span className="highlight">design, code, and AI </span> 
            to build projects that are not just functional, but also{" "}
            <b>unique and impactful</b>.
          </p>
          <p>
            When I'm not coding, you can find me exploring new technologies, 
            creating content, enjoying a good book and writing a novel or poems. Let's connect and build something amazing together!
            </p>

        </div>
      </div>
    </section>
  );
}

export default About;
